"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setNestedValue = exports.getNestedValue = exports.has = exports.objIsEmpty = exports.assign = void 0;
const assign = obj => keyVal => Object.assign({}, obj, keyVal);
exports.assign = assign;
const objIsEmpty = obj => !Object.keys(obj).length;
exports.objIsEmpty = objIsEmpty;
const has = prop => obj => obj !== undefined && obj !== null && typeof obj === 'object' && Object.prototype.hasOwnProperty.call(obj, prop);
exports.has = has;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getNestedValue = (obj, path) => {
  return path.split(/[.[\]]/).filter(Boolean).reduce((acc, key) => acc && acc[key], obj);
};
exports.getNestedValue = getNestedValue;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const setNestedValue = (obj, path, value) => {
  const keys = path.split(/[.[\]]/).filter(Boolean); // Split by dot or brackets and remove empty strings
  return keys.reduce((acc, key, index) => {
    if (index === keys.length - 1) {
      // If it's the last key, set the value
      acc[key] = value;
    } else {
      // Convert the next key to a number to check if it's an array index
      const nextKey = keys[index + 1];
      if (!acc[key]) {
        acc[key] = isNaN(Number(nextKey)) ? {} : []; // Check if the next key is a number
      }
    }

    return acc[key];
  }, obj);
};
exports.setNestedValue = setNestedValue;